import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [msg, setMsg] = useState("Google oturumunuz doğrulanıyor…");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    // Read session_id from URL fragment
    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setMsg("Oturum bilgisi bulunamadı");
      setTimeout(() => nav("/giris", { replace: true }), 1500);
      return;
    }
    // Clean URL
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        toast.success("Hoş geldiniz!");
        nav("/", { replace: true });
      } catch (e) {
        toast.error("Google girişi başarısız");
        nav("/giris", { replace: true });
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-muted-foreground">{msg}</p>
      </div>
    </div>
  );
}
